import Card from '@mui/material/Card';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

const MAX_CARDS_ON_DESKTOP = 3;

const HeaderSkeleton = () => (
  <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
    <Skeleton
      variant="rounded"
      sx={{
        display: { md: 'none' },
        width: '5rem',
        height: '4.5rem',
        borderRadius: '1rem',
      }}
      data-testid="skeleton-hero-image"
    />
    <Stack spacing={0.5} sx={{ flex: 1 }}>
      <Skeleton
        variant="text"
        width="60%"
        height={20}
        data-testid="skeleton-subtitle"
      />
      <Skeleton
        variant="text"
        sx={{ width: { xs: '40%', md: '12rem' }, height: { xs: 32, md: 40 } }}
        data-testid="skeleton-title"
      />
    </Stack>
  </Stack>
);

const CategoryCardsSkeleton = () => (
  <Stack
    spacing={{ xs: 1, md: 1.5 }}
    direction={{ md: 'row' }}
    sx={{
      alignItems: { md: 'center' },
      whiteSpace: { md: 'nowrap' },
      overflowX: { md: 'scroll' },
    }}
    useFlexGap
  >
    {[...Array(4)].map((_, index) => (
      <Card
        key={index}
        variant="outlined"
        sx={{
          borderRadius: 1.5,
          minWidth: '19.25rem',
          display: { md: index >= MAX_CARDS_ON_DESKTOP ? 'none' : 'block' },
        }}
      >
        <Stack
          direction="row"
          spacing={1.5}
          sx={{ alignItems: 'center', p: 1, pr: 2 }}
        >
          <Skeleton
            variant="rounded"
            sx={{
              minWidth: { xs: '3rem', md: '5rem' },
              height: { xs: '3rem', md: '5rem' },
              borderRadius: 1,
            }}
            data-testid={`skeleton-category-icon-${index}`}
          />
          <Stack sx={{ flexGrow: 1 }} spacing={0.5}>
            <Skeleton
              variant="text"
              width="60%"
              height={28}
              data-testid={`skeleton-category-name-${index}`}
            />
            <Skeleton
              variant="text"
              width="40%"
              height={16}
              data-testid={`skeleton-category-count-${index}`}
            />
          </Stack>
          <Skeleton
            variant="circular"
            width={24}
            height={24}
            data-testid={`skeleton-category-arrow-${index}`}
          />
        </Stack>
      </Card>
    ))}
  </Stack>
);

const RecommendedCategoriesSkeleton = () => (
  <Stack
    spacing={{ xs: 1.5, sm: 2, md: 5 }}
    direction={{ md: 'row' }}
    sx={{ minHeight: { xs: '26.875rem', md: '6rem' } }}
    useFlexGap
    data-testid="recommended-categories-skeleton"
  >
    <HeaderSkeleton />
    <CategoryCardsSkeleton />
  </Stack>
);

export default RecommendedCategoriesSkeleton;
